import React from 'react';

// This is required to fudge some of the typing with Chakra
export const Icons: { [key: string]: any } = {
  ANGLE_DOUBLE_RIGHT: 'angleDoubleRight',
  CLEAR: 'clear',
  CLOCK: 'clock',
  ELLIPSIS_H: 'ellipsisH',
  EPIC: 'epic',
  EXTERNAL_LINK: 'externalLink',
  FOLDER: 'folder',
  HOME: 'home',
  ISSUES: 'issues',
  LIST_BULLETED: 'listBulleted',
  MERGE_REQUEST: 'mergeRequest',
  PENCIL_SQUARE: 'pencilSquare',
  THUMBTACK: 'thumbtack',
  WEIGHT: 'weight',
};

export const customIcons = {
  angleDoubleRight: {
    path: (
      <path
        fill="currentColor"
        d="M3.70711,2.29289 L8.70711,7.29289 C9.09763,7.68342 9.09763,8.31658 8.70711,8.70711 L3.70711,13.7071 C3.31658,14.0976 2.68342,14.0976 2.29289,13.7071 C1.90237,13.3166 1.90237,12.6834 2.29289,12.2929 L6.58579,8 L2.29289,3.70711 C1.90237,3.31658 1.90237,2.68342 2.29289,2.29289 C2.68342,1.90237 3.31658,1.90237 3.70711,2.29289 Z M8.70711,2.29289 L13.7071,7.29289 C14.0976,7.68342 14.0976,8.31658 13.7071,8.70711 L8.70711,13.7071 C8.31658,14.0976 7.68342,14.0976 7.29289,13.7071 C6.90237,13.3166 6.90237,12.6834 7.29289,12.2929 L11.5858,8 L7.29289,3.70711 C6.90237,3.31658 6.90237,2.68342 7.29289,2.29289 C7.68342,1.90237 8.31658,1.90237 8.70711,2.29289 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  clear: {
    path: (
      <path
        fill="currentColor"
        d="M8,16 C12.4183,16 16,12.4183 16,8 C16,3.58172 12.4183,0 8,0 C3.58172,0 0,3.58172 0,8 C0,12.4183 3.58172,16 8,16 Z M4.29289,4.29289 C4.68342,3.90237 5.31658,3.90237 5.70711,4.29289 L8,6.58579 L10.2929,4.29289 C10.6834,3.90237 11.3166,3.90237 11.7071,4.29289 C12.0976,4.68342 12.0976,5.31658 11.7071,5.70711 L9.41421,8 L11.7071,10.2929 C12.0976,10.6834 12.0976,11.3166 11.7071,11.7071 C11.3166,12.0976 10.6834,12.0976 10.2929,11.7071 L8,9.41421 L5.70711,11.7071 C5.31658,12.0976 4.68342,12.0976 4.29289,11.7071 C3.90237,11.3166 3.90237,10.6834 4.29289,10.2929 L6.58579,8 L4.29289,5.70711 C3.90237,5.31658 3.90237,4.68342 4.29289,4.29289 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  clock: {
    path: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9 4v3.586l1.707 1.707a1 1 0 0 1-1.414 1.414L7 8.414V4a1 1 0 0 1 2 0zm7 4A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-2 0A6 6 0 1 0 2 8a6 6 0 0 0 12 0z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  ellipsisH: {
    path: (
      <path
        fill="currentColor"
        d="M2,6 C3.10457,6 4,6.89543 4,8 C4,9.10457 3.10457,10 2,10 C0.895431,10 0,9.10457 0,8 C0,6.89543 0.895431,6 2,6 Z M8,6 C9.10457,6 10,6.89543 10,8 C10,9.10457 9.10457,10 8,10 C6.89543,10 6,9.10457 6,8 C6,6.89543 6.89543,6 8,6 Z M14,6 C15.1046,6 16,6.89543 16,8 C16,9.10457 15.1046,10 14,10 C12.8954,10 12,9.10457 12,8 C12,6.89543 12.8954,6 14,6 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  epic: {
    path: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.3911376,1.00166302 C12.8433376,1.00174802 13.2392376,1.30536402 13.3566376,1.74212402 L14.9691376,7.74209402 C15.1399376,8.37744402 14.6611376,9.00172402 14.0032376,9.00163402 L3.00103757,9.00016402 L3.00103757,10.003784 L13.0010376,10.003784 C13.5533376,10.003784 14.0010376,10.451484 14.0010376,11.003784 C14.0010376,11.556084 13.5533376,12.003784 13.0010376,12.003784 L4.00103757,12.003784 L4.00103757,13.003784 L12.0010376,13.003784 C12.5533376,13.003784 13.0010376,13.451484 13.0010376,14.003784 C13.0010376,14.556084 12.5533376,15.003784 12.0010376,15.003784 L4.00103757,15.003784 C2.89646757,15.003784 2.00103757,14.108384 2.00103757,13.003784 L2.00103757,11.736184 C1.40323757,11.390384 1.00103757,10.744084 1.00103757,10.003784 L1.00103757,8.04725402 C0.996438566,7.94705402 1.00702757,7.84391402 1.03481757,7.74048402 L2.64732757,1.74046402 C2.76474757,1.30356402 3.16084757,1 3.61324757,1 L12.3911376,1.00166302 Z M11.6241376,3.00151402 L12.6991376,7.00145402 L3.30473757,7.00020402 L4.37975757,3.00014402 L11.6241376,3.00151402 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  externalLink: {
    path: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5,2 C5.55228,2 6,2.44772 6,3 C6,3.55228 5.55228,4 5,4 L4,4 L4,12 L12,12 L12,11 C12,10.4477 12.4477,10 13,10 C13.5523,10 14,10.4477 14,11 L14,12 C14,13.1046 13.1046,14 12,14 L4,14 C2.89543,14 2,13.1046 2,12 L2,4 C2,2.89543 2.89543,2 4,2 L5,2 Z M15,1 L15,5.99814453 C15,6.55043453 14.5523,6.99814453 14,6.99814453 C13.4477,6.99814453 13,6.55043453 13,5.99814453 L13,4.41419 L8.71571,8.69846 C8.32519,9.08899 7.69202,9.08899 7.3015,8.69846 C6.91097,8.30794 6.91097,7.67477 7.3015,7.28425 L11.5858,3 L9.99619141,3 C9.44391141,3 8.99619141,2.55228 8.99619141,2 C8.99619141,1.44772 9.44391141,1 9.99619141,1 L15,1 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  folder: {
    path: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9,4 L13,4 C14.1046,4 15,4.89543 15,6 L15,12 C15,13.1046 14.1046,14 13,14 L3,14 C1.89543,14 1,13.1046 1,12 L1,4 C1,2.89543 1.89543,2 3,2 L6.58579,2 C6.851,2 7.10536,2.10536 7.29289,2.29289 L9,4 Z M3,12 L3,6 L13,6 L13,12 L3,12 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  home: {
    path: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.4847,5.328 L7.99238,1 L0.499976,5.328 C0.0217345,5.60426 -0.141992,6.21588 0.134253,6.69411 C0.317938,7.0121 0.649908,7.19109 0.992346,7.19408 L1.99235,7.19408 L1.99235,14.0298 L13.9923,14.0298 L13.9923,7.19408 L14.9921,7.19408 C15.3346,7.19118 15.6667,7.01218 15.8505,6.69411 C16.1267,6.21588 15.963,5.60426 15.4847,5.328 Z M11.9923,5.62031 L7.99238,3.30971 L3.99235,5.62034 L3.99235,12.0298 L6.99235,12.0298 L6.99235,9.02985 L8.99235,9.02985 L8.99235,12.0298 L11.9923,12.0298 L11.9923,5.62031 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  issues: {
    path: (
      <path
        fillRule="evenodd"
        fill="currentColor"
        d="M1,3 C1,1.89543 1.89543,1 3,1 L9,1 C9.96059,1 10.763,1.6772 10.9559,2.58023 L13.9947,4.33469 C14.9513,4.88698 15.279,6.11016 14.7267,7.06674 C13.4456,9.28574 11,13.5146 10.8452,13.7866 C10.457,14.4688 9.81319,15 9,15 L3,15 C1.89543,15 1,14.1046 1,13 L1,3 Z M3,3 L9,3 L9,13 L3,13 L3,3 Z M11,9.52164 L12.9947,6.06674 L11,4.91511 L11,9.52164 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  listBulleted: {
    path: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.5,4.5 C3.32843,4.5 4,3.82843 4,3 C4,2.17157 3.32843,1.5 2.5,1.5 C1.67157,1.5 1,2.17157 1,3 C1,3.82843 1.67157,4.5 2.5,4.5 Z M7,2 C6.44772,2 6,2.44772 6,3 C6,3.55228 6.44772,4 7,4 L14,4 C14.5523,4 15,3.55228 15,3 C15,2.44772 14.5523,2 14,2 L7,2 Z M6,8 C6,7.44772 6.44772,7 7,7 L14,7 C14.5523,7 15,7.44772 15,8 C15,8.55229 14.5523,9 14,9 L7,9 C6.44772,9 6,8.55229 6,8 Z M2.5,9.5 C3.32843,9.5 4,8.82843 4,8 C4,7.17157 3.32843,6.5 2.5,6.5 C1.67157,6.5 1,7.17157 1,8 C1,8.82843 1.67157,9.5 2.5,9.5 Z M6,13 C6,12.4477 6.44772,12 7,12 L14,12 C14.5523,12 15,12.4477 15,13 C15,13.5523 14.5523,14 14,14 L7,14 C6.44772,14 6,13.5523 6,13 Z M2.5,14.5 C3.32843,14.5 4,13.8284 4,13 C4,12.1716 3.32843,11.5 2.5,11.5 C1.67157,11.5 1,12.1716 1,13 C1,13.8284 1.67157,14.5 2.5,14.5 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  mergeRequest: {
    path: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10,0 L10,2.60002 C12.2108812,3.04881281 13.8920863,4.95644867 13.9950026,7.27443311 L14,7.5 L14,11.2676 C14.5978,11.6134 15,12.2597 15,13 C15,14.1046 14.1046,15 13,15 C11.8954,15 11,14.1046 11,13 C11,12.3166462 11.342703,11.713387 11.8656124,11.3526403 L12,11.2676 L12,7.5 C12,6.259091 11.246593,5.19415145 10.1722389,4.73766702 L10,4.67071 L10,7 L6,3.5 L10,0 Z M3,1 C4.10457,1 5,1.89543 5,3 C5,3.68333538 4.65729704,4.28663574 4.13438762,4.6473967 L4,4.73244 L4,11.2676 C4.5978,11.6134 5,12.2597 5,13 C5,14.1046 4.10457,15 3,15 C1.89543,15 1,14.1046 1,13 C1,12.3166462 1.34270296,11.713387 1.86561238,11.3526403 L2,11.2676 L2,4.73244 C1.4022,4.38663 1,3.74028 1,3 C1,1.89543 1.89543,1 3,1 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  pencilSquare: {
    path: (
      <path
        fill="currentColor"
        d="M8,2 C8.55229,2 9,2.44771 9,3 C9,3.55228 8.55229,4 8,4 L4,4 L4,12 L12,12 L12,8 C12,7.44771 12.4477,7 13,7 C13.5523,7 14,7.44771 14,8 L14,12 C14,13.1046 13.1046,14 12,14 L4,14 C2.89543,14 2,13.1046 2,12 L2,4 C2,2.89543 2.89543,2 4,2 L8,2 Z M11.9531,2.63268 L13.3673,4.04689 L7.41421,10 L6,10 L6,8.58579 L11.9531,2.63268 Z M14.7815,1.21846 C15.1721,1.60898 15.1721,2.24215 14.7815,2.63267 L14.0744,3.33979 L12.6602,1.92556737 L13.3673,1.21846 C13.7578,0.827937 14.391,0.827936 14.7815,1.21846 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  thumbtack: {
    path: (
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.0001,4.58579 C15.3906,4.97631 15.3906,5.60948 15.0001,6 C14.6787,6.32133 14.1931,6.37826 13.8136,6.1708 L11,8.98435 L11,10.5858 C11,11.4767 9.92288,11.9229 9.29292,11.2929 L8,9.99998 L2.55627,14.5364 C2.19684,14.836 1.743773,15 1.2759,15 L1,15 L1,14.7241 C1,14.2562 1.164032,13.8032 1.463557,13.4437 L6,8 L4.70713,6.707106 C4.07716,6.07714 4.52333,5 5.41424,5 L7.01953,5 L9.83055,2.18899 C9.62146,1.80908 9.67793,1.32204 9.99997,0.999999 C10.3905,0.609475 11.0237,0.609475 11.4142,0.999999 L15.0001,4.58579 Z M7.84796,7 L11.2169,3.63108 L12.3709,4.78506 L9.00002,8.15592 L9.00002,8.17157 L7.82845,7 L7.84796,7 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
  weight: {
    path: (
      <path
        fill="currentColor"
        d="M10.2361,6 C10.7111,5.46924 11,4.76835 11,4 C11,2.34315 9.65685,1 8,1 C6.34315,1 5,2.34315 5,4 C5,4.76835 5.28885,5.46924 5.76389,6 L3.00003,6 L1.26411,12.4827 C0.923988,13.7528 1.88112,15 3.19604,15 L12.8013,15 C14.1159,15 15.073,13.7534 14.7334,12.4834 L13,6 L10.2361,6 Z M9,4 C9,4.55228 8.55228,5 8,5 C7.44772,5 7,4.55228 7,4 C7,3.44772 7.44772,3 8,3 C8.55228,3 9,3.44772 9,4 Z M3.19604,13 L4.53493,8 L11.4645,8 L12.8013,13 L3.19604,13 Z"
      />
    ),
    viewBox: '0 0 16 16',
  },
};
